import { CartScreen } from '../features/cart/CartScreen'

export function CartPage() {
  return <CartScreen />
}
